<template>
  <div>
    <a-button type="primary" @click="showModal">View / Manage Medical History</a-button>
    <a-drawer
      :title="'Medical History for ' + studentData.first_name + ' ' + studentData.last_name"
      :width="this.settings['isMobileView'] ? 300 : this.settings['isTabletView'] ? 720 : 960"
      @close="handleCancel"
      :visible="visible"
      :wrapStyle="{height: 'calc(100% - 10px)', overflow: 'auto', paddingBottom: '10px'}"
      placement="right"
    >
      <div>
        <div class="row">
          <div class="col-12 pb-4">
            <add-medical-history :studentId="studentData.id" @created="handleCreated"/>
          </div>
          <a-divider />
        </div>
        <div class="col-12" v-if="medicalHistory.length">
          <a-spin :spinning="loading" tip="Loading">
            <div v-for="medicalData in medicalHistory" :key="medicalData.id">
              <div class="row py-3">
                <div class="col-md-4 mb-2">
                  Recorded on: <strong>{{ moment(medicalData.recorded_on).format(dateFormat)}}</strong>
                </div>
                <div class="col-md-4 mb-2">
                  Height: <strong>{{ medicalData.height}}</strong>
                </div>
                <div class="col-md-4 mb-2">
                  Weight: <strong>{{ medicalData.weight}}</strong>
                </div>
                <div class="col-md-4 mb-2">
                  Test type: <strong>{{ medicalData.test_type}}</strong>
                </div>
                <div class="col-md-4 mb-2">
                  Test result: <strong>{{ medicalData.test_result}}</strong>
                </div>
                <div class="col-md-4 mb-2 d-flex inline-flex">
                  <edit-medical-history :medicalData="medicalData" :studentId="studentData.id" @updated="handleUpdated"/>
                  <div class="ml-2">
                    <a-button type="danger" @click="deleteMedicalHistory(medicalData.id)">Delete</a-button>
                  </div>
                </div>
              </div>
              <a-divider />
            </div>
          </a-spin>
        </div>
        <div class="col-12 py-5 mt-3 text-center bg-light" v-else>
          <p>No medical data found for this student</p>
        </div>
      </div>

    </a-drawer>
  </div>
</template>

<style scoped>
.ant-drawer-close-x{
  margin-right: 0.7rem;
}
</style>

<script>
import AddMedicalHistory from '../Forms/Add/index'
import EditMedicalHistory from '../Forms/Edit/index'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'MedicalHistoryList',
  props: ['studentData'],
  components: {
    AddMedicalHistory,
    EditMedicalHistory,
  },
  mounted: function() {},
  data: function() {
    return {
      loading: false,
      visible: false,
      dateFormat: 'DD-MM-YYYY',
      medicalHistory: [],
    }
  },
  computed: mapState(['settings']),
  methods: {
    moment,
    fetchMedicalHistory() {
      this.loading = true
      this.form = this.$form.createForm(this)
      this.$http.get(`/api/student/medicalhistory/${this.studentData.id}`)
        .then(({ data }) => {
          this.medicalHistory = data.data
          this.loading = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    showModal() {
      this.visible = true
      this.fetchMedicalHistory()
    },
    handleCreated() {
      this.fetchMedicalHistory()
    },
    handleUpdated() {
      this.fetchMedicalHistory()
    },
    deleteMedicalHistory(medicalHistoryId) {
      this.$confirm({
        title: 'Are you sure delete this medical record?',
        content: `Click on OK to delete this medical record from student's medical history`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete(`/api/student/medicalhistory/${this.studentData.id}`, {
              params: {
                medical_history_id: medicalHistoryId,
              },
            })
            .then(() => {
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'Medical data has been deleted.',
              })
              this.fetchMedicalHistory()
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    handleCancel(e) {
      this.visible = false
      this.loading = false
    },
  },
}
</script>
